import { observer } from 'mobx-react-lite'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { CommonNumbers } from 'pages/settings/pages/compliance/ui/CommonNumbers/CommonNumbers'
import { useAssignNumberStepsContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/context/useAssignNumberStepsContext'

export const AddSalesmsgNumbers = observer(() => {
  const { addSalesmsgNumbersStore, loading, unassignedNumbersCount } = useAssignNumberStepsContext()
  const {
    numbersStore,
    nextClickHandler,
    loading: addSalesmsgNumbersLoading,
  } = addSalesmsgNumbersStore
  const { isStepDisabled, multiSelectedValues } = numbersStore
  const isMultiSelected = multiSelectedValues.length > 1

  return (
    <div>
      <PageDescription>
        Your workspace has {unassignedNumbersCount} unassigned number
        {unassignedNumbersCount > 1 ? 's' : ''} available
      </PageDescription>

      <CommonNumbers
        loading={addSalesmsgNumbersLoading}
        numbersStore={numbersStore}
        isLabelQuestionTooltip={false}
      />

      <NextButton
        loading={loading}
        disabled={isStepDisabled || loading}
        text={`Assign ${!!multiSelectedValues.length ? multiSelectedValues.length : ''} number${
          isMultiSelected ? 's' : ''
        }`}
        onClick={nextClickHandler}
      />
    </div>
  )
})
